import { TranslatedText } from '../Translation';

export interface Brand {
  id: number;
  slug: string;
  sortOrder: number;
  isActive: boolean;
  showLabel: boolean;
  name: string;
  nameTranslation: TranslatedText;
  logo: string;
  banner: string;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyBrand = (): Brand => ({
  id: 0,
  slug: '',
  sortOrder: 10,
  isActive: false,
  showLabel: true,
  name: '',
  nameTranslation: {},
  logo: '',
  banner: '',
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const brandFromResponse = (responseData: any): Brand => ({
  id: responseData.id,
  slug: responseData.slug,
  sortOrder: responseData.sort_order,
  isActive: responseData.is_active === 1,
  showLabel: responseData.show_label,
  name: responseData.name,
  nameTranslation: responseData.name_translation ?? {},
  logo: responseData.path,
  banner: responseData.banner,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const brandToUpsertRequest = (brand: Brand) => ({
  name: brand.name,
  name_translation: brand.nameTranslation,
  sort_order: brand.sortOrder,
  is_active: brand.isActive,
  show_label: brand.showLabel,
});
